import type { UserProfile } from './generated/gql-enums';

export const USER_PROFILE_ADVISOR = 'ADVISOR' satisfies UserProfile;
export const USER_PROFILE_CLIENT = 'CLIENT' satisfies UserProfile;
